import { createMainAppMicroserviceInstance } from '@servicetitan/cp-api';
import { injectable } from '@servicetitan/react-ioc';
import { Memberships } from './portal-memberships.api';
export {
    MembershipRecurrenceType,
    Memberships,
    MembershipStatus,
    type EquipmentServiceHistoryItem,
    type MembershipEquipmentBaseModel,
    type MembershipDetailVisit,
} from './portal-memberships.api';

@injectable()
export class MembershipsApi {
    private client: Memberships;

    constructor() {
        this.client = new Memberships(
            createMainAppMicroserviceInstance(
                '/v1/customerportal2/memberships',
                '/api/cp/memberships'
            )
        );
    }

    async membershipsExist(): Promise<boolean> {
        const response = await this.client.membershipsExist();
        return response.data;
    }
}
